import envivo from "@envivo/backoffice-components";

const apigClientFactory = envivo.apigClientFactory;

const api = function (config) {
  return apigClientFactory.newClient(config);
};

export default api;
